<script setup lang="ts">
import { cn } from '@/shadcn/lib/utils'
import { TabsList, type TabsListProps } from 'reka-ui'
import { computed, type HTMLAttributes } from 'vue'

const props = defineProps<TabsListProps & { class?: HTMLAttributes['class'] }>()

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})
</script>

<template>
  <TabsList
    data-slot="tabs-list"
    v-bind="delegatedProps"
    :class="cn(
      'tw:bg-muted tw:text-muted-foreground tw:inline-flex tw:min-h-9 tw:w-fit tw:items-center tw:justify-center tw:rounded-lg tw:p-[3px] tw:flex-wrap',
      props.class,
    )"
  >
    <slot />
  </TabsList>
</template>
